'use client';

import React, { useEffect, useState, useCallback } from 'react';

interface Slide {
  url: string;
  alt: string;
  caption: string;
}

const slides: Slide[] = [
{
  url: "https://gglkguiebsolvnjxdbiz.supabase.co/storage/v1/object/public/media-files/image/1787788544676-3.jpg",
  alt: 'Salsa dancers performing on a vibrant stage with colorful lights',
  caption: 'La Pasión de la Salsa'
},
{
  url: "https://gglkguiebsolvnjxdbiz.supabase.co/storage/v1/object/public/media-files/image/1787788547806-6.jpg",
  alt: 'Couple dancing salsa in elegant attire under warm spotlight',
  caption: 'Ritmo y Sabor'
},
{
  url: "https://gglkguiebsolvnjxdbiz.supabase.co/storage/v1/object/public/media-files/image/1787788541381-0.jpg",
  alt: 'Live Latin music band performing on stage with brass instruments',
  caption: 'Música en Vivo'
},
{
  url: "https://gglkguiebsolvnjxdbiz.supabase.co/storage/v1/object/public/media-files/image/1787788522824-0.jpg",
  alt: 'Energetic crowd dancing at a salsa music festival',
  caption: 'El Espíritu del Carnaval'
},
{
  url: "https://gglkguiebsolvnjxdbiz.supabase.co/storage/v1/object/public/media-files/image/1787788543468-2.jpg",
  alt: 'Salsa dancer in red dress spinning gracefully on the dance floor',
  caption: 'Fuego en los Pies'
},
{
  url: "https://images.unsplash.com/photo-1578097986129-799e0883a1d6",
  alt: 'Concert crowd with hands raised at a Latin music event',
  caption: 'Una Noche de Rumba'
}];


const INTERVAL_MS = 4500;

export default function RumbaSlideshow() {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 350);
  }, []);

  const next = useCallback(() => {
    goTo((current + 1) % slides.length);
  }, [current, goTo]);

  const prev = useCallback(() => {
    goTo((current - 1 + slides.length) % slides.length);
  }, [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, INTERVAL_MS);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <div
      className="relative w-full overflow-hidden"
      style={{ height: '650px', minHeight: '320px' }}>
      
      {/* Slide image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-700"
        style={{
          backgroundImage: `url(${slides[current].url})`,
          opacity: transitioning ? 0 : 1
        }}
        role="img"
        aria-label={slides[current].alt} />
      

      {/* Dark overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
          'linear-gradient(to bottom, rgba(13,13,20,0.35) 0%, rgba(13,13,20,0.15) 50%, rgba(13,13,20,0.75) 100%)'
        }} />
      

      {/* Caption */}
      <div
        className="absolute bottom-0 left-0 right-0 px-6 pb-5 pt-10 flex items-end justify-between"
        style={{
          opacity: transitioning ? 0 : 1,
          transition: 'opacity 0.5s ease'
        }}>
        
        <p
          className="text-white font-bold text-sm md:text-base tracking-wide drop-shadow-lg"
          style={{ textShadow: '0 2px 8px rgba(0,0,0,0.8)' }}>
          
          {slides[current].caption}
        </p>

        {/* Dot indicators */}
        <div className="flex items-center gap-1.5">
          {slides.map((_, i) =>
          <button
            key={i}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
            className="rounded-full transition-all duration-300 focus:outline-none"
            style={{
              width: i === current ? '20px' : '7px',
              height: '7px',
              background: i === current ? '#ef4444' : 'rgba(255,255,255,0.45)'
            }} />

          )}
        </div>
      </div>

      {/* Prev / Next arrows */}
      <button
        onClick={prev}
        aria-label="Previous slide"
        className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full flex items-center justify-center transition-all duration-150 focus:outline-none"
        style={{
          background: 'rgba(13,13,20,0.55)',
          border: '1px solid rgba(255,255,255,0.15)',
          backdropFilter: 'blur(6px)'
        }}>
        
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      <button
        onClick={next}
        aria-label="Next slide"
        className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full flex items-center justify-center transition-all duration-150 focus:outline-none"
        style={{
          background: 'rgba(13,13,20,0.55)',
          border: '1px solid rgba(255,255,255,0.15)',
          backdropFilter: 'blur(6px)'
        }}>
        
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>

      {/* Top & bottom edge fades to blend with page background */}
      <div
        className="absolute top-0 left-0 right-0 h-6 pointer-events-none"
        style={{ background: 'linear-gradient(to bottom, var(--background), transparent)' }} />
      
      <div
        className="absolute bottom-0 left-0 right-0 h-6 pointer-events-none"
        style={{ background: 'linear-gradient(to top, var(--background), transparent)' }} />
      
    </div>);

}